import React from 'react'
import { storiesOf } from '@storybook/react'
import withReadme from 'storybook-readme/with-readme'
import { withKnobs, boolean } from '@storybook/addon-knobs/react'
import StaticRenderer from '@emcm-ui/component-static-renderer'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme } from '../..'

// Component to surface in storybook
import DatePicker from '.'
import demoData from './demos/dateProps.json'
import i18n from './demos/LangEN.json'
import readme from './readme.md'
demoData.i18n = i18n

// Story Setup
const stories = storiesOf('Digital-Commons/DatePicker', module)

stories.addDecorator(withReadme(readme))
stories.addDecorator(withKnobs)

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

// Stories
stories
  .add('Default', () => (
    <ThemeProvider theme={builtTheme}>
      <DatePicker {...demoData}
        range={boolean('Enable Ranges', false)}
        preventFutureDates={boolean('Prevent Future Dates', false)}
      />
    </ThemeProvider>
  )).add("Rehydrated", () => {
    return (
      <StaticRenderer>
        <ThemeProvider theme={builtTheme}>
          <DatePicker {...demoData}
            range={boolean('Enable Ranges', false)}
            preventFutureDates={boolean('Prevent Future Dates', false)}
          />
        </ThemeProvider>
      </StaticRenderer>
    )
  })
